import { useStreetLight } from '../../../../hooks'
import { useEffect } from 'react'
import StreetLightListView from './StreetLightListView/StreetLightListView'
import { useMicroNavigator } from '../../../../../../common/components/organisme/MicroNavigator/MicroNavigatorContext'
import { useCapability } from '../../../../../rbac'

export default function StreetLightListPresenter() {
  const {getAllStreetLightsQuery: {data, isLoading, refetch}, deleteStreetLightMutation} = useStreetLight()

  const {navigate} = useMicroNavigator()
  const canEdit = useCapability('planbt.edit')

  useEffect(() => {
    refetch()
  },[]) // eslint-disable-line
  
  const handleDelete = (id: string) => {
    deleteStreetLightMutation.mutate({streetLightId: id})
  }// eslint-disable-line
  return (
    <StreetLightListView  streetLightList={data?.data} isLoading={isLoading} onClickItem={(id) => {
      navigate('single', {streetLightId: id})
    }} 
    deleteStreetLight={canEdit ? handleDelete : undefined}
    updateStreetLight={canEdit ? (id) => {
      navigate('edit', {streetLightId: id})
    } : undefined}
    />
  )
}
